import styled from "styled-components";
const WorkPageWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .heading {
    width: 80vw;
    text-align: start;
    align-self: flex-start;
    margin-left: 10%;
    padding: 20px;
    border-bottom: 2px solid #64ffda45;
  }
`;
export default WorkPageWrapper;
